/**
 * @generated SignedSource<<1c44aef4ce4d3d2878d5fabff5bac7c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type mostPopularQueueQuery$data = {
  readonly mostPopularQueueQuery: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly trendingTopicsQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"trendingTopicTopic">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "mostPopularQueueQuery";
};
export type mostPopularQueueQuery$key = {
  readonly " $data"?: mostPopularQueueQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"mostPopularQueueQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "trendingTopicsQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "mostPopularQueueQuery",
  "selections": [
    {
      "alias": "mostPopularQueueQuery",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "scmp_trending_section_scmp_trending_section_homepage_last_24_hours"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "contentItemRenderContent"
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:5)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_homepage_last_24_hours\"})"
    },
    {
      "alias": "trendingTopicsQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "trendingTopicsQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "trendingTopicTopic"
                        }
                      ],
                      "type": "Topic",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:5)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "7ed58e541ff7ffb83c92b548a3497b11";

export default node;
